<template>
    <div class="form-group">
        <label class="form-label section-title">{{ $t('messages.campaign_name') }}</label>
        <div class="campaign-name-row">
            <input type="text" class="form-input" :value="value" :placeholder="$t('messages.enter_campaign_name')"
                @input="handleInput" />
            <label class="checkbox test-campaign-checkbox" :title="$t('messages.test_campaign_hint')">
                <input type="checkbox" :checked="isTest" @change.stop="handleTestChange" />
                <span class="checkbox-label">{{ $t('messages.test_campaign') }}</span>
            </label>
        </div>
    </div>
</template>

<script>
export default {
    name: "CampaignName",
    emits: ['input', 'update:isTest'],
    props: {
        value: {
            type: String,
            default: ''
        },
        isTest: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        handleInput(event) {
            let inputValue = event.target.value;
            inputValue = inputValue.replace(/[\\\/]/g, '');
            event.target.value = inputValue;
            this.$emit('input', inputValue);
        },
        handleTestChange(event) {
            this.$emit('update:isTest', event.target.checked);
        }
    }
};
</script>

<style scoped>
.campaign-name-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 16px;
}

.campaign-name-row .form-input {
    flex: 1;
    min-width: 0;
}

.test-campaign-checkbox {
    flex-shrink: 0;
    white-space: nowrap;
}
</style>
